import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--thick-left",
  "use": "icon-arrow--thick-left-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-arrow--thick-left\"><mask id=\"icon-arrow--thick-left_a\" fill=\"#fff\"><path d=\"M6 12 .343 6.343 6 .686l5.657 5.657L6 12Z\" /></mask><path d=\"M.343 6.343-1.07 4.93l-1.414 1.414 1.414 1.414L.343 6.343Zm7.071 4.243L1.757 4.929-1.07 7.757l5.657 5.657 2.828-2.828ZM1.757 7.757 7.414 2.1 4.586-.728-1.071 4.93l2.828 2.828Z\" fill=\"currentColor\" mask=\"url(#icon-arrow--thick-left_a)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol